import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigator"
export default class extends Controller {
  static targets = [ "item" ]

  connect() {
  }

  toggle(event) {
    // event.currentTargetがすでにactiveだったら何もしない
    if (event.currentTarget.classList.contains("active"))
      return

    event.currentTarget.classList.toggle("active")
    this.itemTargets.forEach((item) => {
      if (item !== event.currentTarget) {
        item.classList.remove("active")
      }
    })
  }
}
